"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.object.keys.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.array.filter.js");

require("core-js/modules/es6.object.get-own-property-descriptor.js");

require("core-js/modules/es7.object.get-own-property-descriptors.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.map.js");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactRedux = require("react-redux");

var _MenuItem = _interopRequireDefault(require("material-ui/MenuItem"));

var _Card = require("material-ui/Card");

var _DashPage = _interopRequireDefault(require("./shared/elements/DashPage"));

var _AddResource = _interopRequireDefault(require("./internalDash/AddResource"));

var _ResourceListItem = _interopRequireDefault(require("./shared/elements/ResourceListItem"));

var _UniversalDashModal = _interopRequireDefault(require("./shared/elements/UniversalDashModal"));

var _SelectFieldWrapper = _interopRequireDefault(require("./shared/elements/SelectFieldWrapper"));

var _resources = require("@evdy/web-redux/dist/actions/dash/resources");

require("../sass/ResourceCenter.css");

var _dec, _class;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var fileTypes = ['PDF', 'Video'];
var sortCategories = [['Date Added', '-createdAt'], ['Alphabetical', 'title'], ['File Type', 'filetype']];
var ResourceCenter = (_dec = (0, _reactRedux.connect)(function (_ref) {
  var dash = _ref.dash,
      routing = _ref.routing;
  return {
    resources: dash.resources,
    routing: routing
  };
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(ResourceCenter, _React$Component);

  var _super = _createSuper(ResourceCenter);

  function ResourceCenter(props) {
    var _this;

    _classCallCheck(this, ResourceCenter);

    _this = _super.call(this, props);
    _this.state = {
      filters: {
        filetype: '',
        sort: ''
      },
      totalPages: 0,
      universalModalOpen: false,
      resource: {
        filetype: 'PDF',
        featured: false
      }
    };
    _this.updateStateAndFetchResources = _this.updateStateAndFetchResources.bind(_assertThisInitialized(_this));
    _this.handleMainButtonFn = _this.handleMainButtonFn.bind(_assertThisInitialized(_this));
    _this.openAddModal = _this.openAddModal.bind(_assertThisInitialized(_this));
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.onEditClick = _this.onEditClick.bind(_assertThisInitialized(_this));
    _this.renderResources = _this.renderResources.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ResourceCenter, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$props = this.props,
          resources = _this$props.resources,
          routing = _this$props.routing;
      var locationBeforeTransitions = routing.locationBeforeTransitions;

      if (resources.lastUpdated < Date.now() - 1e3) {
        this.props.dispatch((0, _resources.fetchResources)());
      }

      if (locationBeforeTransitions) this.isInternal = locationBeforeTransitions.pathname.indexOf('employee') === 1;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props$resources = this.props.resources,
          data = _this$props$resources.data,
          updatedData = _this$props$resources.updatedData;

      if (data !== nextProps.resources.data) {
        this.handleCloseModal();
      }
    }
  }, {
    key: "updateStateAndFetchResources",
    value: function updateStateAndFetchResources(name) {
      var _this2 = this;

      return function (event, idx, value) {
        var filters = _objectSpread(_objectSpread({}, _this2.state.filters), {}, _defineProperty({}, name, value));

        _this2.setState({
          filters: filters
        });

        _this2.props.dispatch((0, _resources.fetchResources)(filters));
      };
    }
  }, {
    key: "handleCloseModal",
    value: function handleCloseModal() {
      this.setState({
        universalModalOpen: false,
        resource: {},
        requiredFieldsMet: false
      });
    }
  }, {
    key: "handleMainButtonFn",
    value: function handleMainButtonFn() {
      var resource = this.state.resource;
      var actionCreator = resource._id ? _resources.editResource : _resources.addResource;
      this.props.dispatch(actionCreator(resource));
    }
  }, {
    key: "onEditClick",
    value: function onEditClick(resource, idx) {
      var _this3 = this;

      return function () {
        _this3.setState({
          resource: _objectSpread({}, resource)
        });

        _this3.openAddModal();
      };
    }
  }, {
    key: "openAddModal",
    value: function openAddModal() {
      this.setState({
        universalModalOpen: true
      });
    }
  }, {
    key: "renderResources",
    value: function renderResources(resource, idx) {
      if (!this.isInternal && !resource.isActive) return null;
      return /*#__PURE__*/_react.default.createElement(_ResourceListItem.default, {
        key: resource._id || idx,
        resourceData: resource,
        onEditClick: this.onEditClick(resource, idx),
        isInternal: this.isInternal
      });
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(resourceField, fieldType) {
      var _this4 = this;

      switch (fieldType) {
        case 'select':
          return function (event, idx, value) {
            _this4.handleInputValueChange(resourceField, value);
          };

        case 'file':
          return function (value) {
            _this4.handleInputValueChange(resourceField, value);
          };

        case 'toggle':
          return function (event, isInputChecked) {
            _this4.handleInputValueChange(resourceField, isInputChecked);
          };

        default:
          return function (event) {
            var target = event.target;
            var value = target.value;

            _this4.handleInputValueChange(resourceField, value);
          };
      }
    }
  }, {
    key: "handleInputValueChange",
    value: function handleInputValueChange(resourceField, value) {
      var nextStateObj = _objectSpread({}, this.state.resource);

      nextStateObj[resourceField] = value;

      var nextState = _objectSpread(_objectSpread({}, this.state), {}, {
        resource: nextStateObj,
        requiredFieldsMet: this.checkValidation(nextStateObj)
      });

      this.setState(nextState);
    }
  }, {
    key: "checkValidation",
    value: function checkValidation(resource) {
      var title = resource.title,
          subtitle = resource.subtitle,
          url = resource.url,
          filetype = resource.filetype;

      if (title && subtitle && url && filetype) {
        return true;
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var resources = this.props.resources.data;
      var _this$state$filters = this.state.filters,
          filetype = _this$state$filters.filetype,
          sort = _this$state$filters.sort;
      var topFilterOverlayClasses = (0, _classnames.default)({
        'filter-overlay': true,
        'top-overlay': true
      });
      var universalModalOpen = this.state.universalModalOpen;
      return /*#__PURE__*/_react.default.createElement(_DashPage.default, {
        ignoreMainCard: true,
        customClass: "resource-page",
        extraButtonText: this.isInternal ? 'Create Resource' : '',
        extraButtonFn: this.openAddModal
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "search-section"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "resource-button",
        onClick: this.openAddModal
      }, "Add Resource")), /*#__PURE__*/_react.default.createElement(_Card.Card, {
        className: "res-center-viewer-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "search-and-filters"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: topFilterOverlayClasses
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "filter-section"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "left-filter-container"
      }, /*#__PURE__*/_react.default.createElement(_SelectFieldWrapper.default, {
        id: "file-type-filter",
        value: filetype,
        onChange: this.updateStateAndFetchResources('filetype')
      }, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        className: "filter-menu-item",
        primaryText: "All Resources",
        value: ""
      }), fileTypes.map(function (fileType) {
        return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
          key: fileType,
          value: fileType,
          primaryText: fileType,
          className: "filter-menu-item"
        });
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "right-filter-container"
      }, /*#__PURE__*/_react.default.createElement(_SelectFieldWrapper.default, {
        id: "sort-filter",
        value: sort,
        onChange: this.updateStateAndFetchResources('sort')
      }, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        name: "sort",
        className: "filter-menu-item",
        primaryText: "Sort by",
        value: ""
      }), sortCategories.map(function (sortBy) {
        return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
          key: sortBy[0],
          value: sortBy[1],
          primaryText: sortBy[0],
          className: "filter-menu-item"
        });
      }))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "expander-container"
      }, resources.map(this.renderResources))), universalModalOpen && /*#__PURE__*/_react.default.createElement(_UniversalDashModal.default, {
        closeableWithOverlay: true,
        headerTitle: "Add Resource",
        mainButtonText: "save",
        mainButtonFn: this.handleMainButtonFn,
        closeModal: function closeModal() {
          return _this5.handleCloseModal();
        },
        disabled: !this.state.requiredFieldsMet
      }, /*#__PURE__*/_react.default.createElement(_AddResource.default, {
        handleInputChange: this.handleInputChange,
        resource: this.state.resource
      })));
    }
  }]);

  return ResourceCenter;
}(_react.default.Component)) || _class);
exports.default = ResourceCenter;